module.exports = __webpack_public_path__ + "static/media/fondo.d4281aa9.png";